import React from 'react';
import ResearchAnswerQuestions from '../components/ResearchAnswerQuestions';

const DoctorContinueAnswer = () => {
  // Pass through to ResearchAnswerQuestions, which should handle the query params
  return <ResearchAnswerQuestions />;
};

export default DoctorContinueAnswer;